module.exports = __webpack_public_path__ + "Upload.png";